"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = Loader;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const loader_module_scss_1 = __importDefault(require("./loader.module.scss"));
function Loader({ children, className, itemContainerClassName, itemClassName, backgroundColor, foregroundColor, isFullScreen = false, isInline = false, isVertical = false, loaderItemCount = 4, kind = 'dot', size = 'xs' }) {
    const classes = (0, classnames_1.default)({
        [loader_module_scss_1.default['container']]: true,
        [loader_module_scss_1.default['container--fullScreen']]: isFullScreen,
        [loader_module_scss_1.default['container--inline']]: isInline,
        [`u-bgColor--${backgroundColor}`]: backgroundColor
    }, className);
    const itemContainerClasses = (0, classnames_1.default)({
        [loader_module_scss_1.default['itemContainer']]: true,
        [loader_module_scss_1.default['itemContainer--vertical']]: isVertical
    }, itemContainerClassName);
    const itemClasses = (0, classnames_1.default)(loader_module_scss_1.default[kind], {
        [loader_module_scss_1.default[`${kind}--${size}`]]: size,
        [`u-bgColor--${foregroundColor}`]: foregroundColor
    }, itemClassName);
    let items = [];
    for (let i = 0; i < loaderItemCount; i++) {
        items.push((0, jsx_runtime_1.jsx)("div", { className: itemClasses }, `item${i}`));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes, children: [children, (0, jsx_runtime_1.jsx)("div", { className: itemContainerClasses, children: items })] }));
}
Loader.propTypes = {
    /** If a child exists, the loader will wrap below it by default. */
    children: prop_types_1.default.node,
    /** Class name list applied to the container element. */
    className: prop_types_1.default.string,
    /** Class name list applied to the loader items container element. */
    itemContainerClassName: prop_types_1.default.string,
    /** Class list applied to each loader item. */
    itemClassName: prop_types_1.default.string,
    /** Background color of the contianer. The color will leverage the color utilities and be prepended with `u-bgColor--` */
    backgroundColor: prop_types_1.default.string,
    /** Color of the dot. The color will leverage the color utilities and be prepended with `u-bgColor--` */
    foregroundColor: prop_types_1.default.string,
    /** Sets loader and children to be inline together. */
    isInline: prop_types_1.default.bool,
    /** Sets loader container to cover the entire viewport. */
    isFullScreen: prop_types_1.default.bool,
    /** Stack loader items vertically. */
    isVertical: prop_types_1.default.bool,
    /** Number of loader items. */
    loaderItemCount: prop_types_1.default.number,
    /** Kind of loader item. Currently there is only one type: "dot" */
    kind: prop_types_1.default.oneOf(['dot']),
    /** Relative size of loader items, follows grid point system. */
    size: prop_types_1.default.oneOf(['xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl'])
};
//# sourceMappingURL=loader.js.map